/**
 * ChMin / ChMax: the lowest and highest chainage the trace actually reaches.
 * These can lie away from the named crossings (centreline, SPL, invert)
 * where a trace turns between them, and are not limited to the log: a trace
 * running past a log end reports where it really ends, so ChMin can be
 * negative and ChMax can exceed the End Chainage.
 */
// A value that rounds to zero prints as 0, never "-0".
const fmt1 = (v) => (Number(v) + 0).toFixed(1).replace(/^-(0\.0)$/, "$1").replace(/\.0$/, "");

export function chainageExtent(a, b) {
  const lo = Math.min(a, b);
  const hi = Math.max(a, b);
  if (![lo, hi].every(Number.isFinite)) return { chmin: "-", chmax: "-" };
  return { chmin: fmt1(lo), chmax: fmt1(hi) };
}

/** A trace that runs the whole log (parallel cases). */
export const fullLogExtent = (startrd, endrd) =>
  chainageExtent(Number(startrd) || 0, Number(endrd));

export const NO_EXTENT = { chmin: "-", chmax: "-" };
